import React from 'react';
import {Badge} from 'reactstrap';
import {constants} from '@neosvoc/nv-platform-core-common';
import UserRoleText from './UserRoleText';

const COLOR_MAP = {
    [constants.USER_ROLES.ADMIN]: 'warning',
    [constants.USER_ROLES.ORGANIZATION_ADMIN]: 'dark',
};

const UserRoleBadge = ({role, ...rest}) => (
    <Badge {...rest} color={COLOR_MAP[role] || 'info'}>
        <UserRoleText role={role} />
    </Badge>
);

export default UserRoleBadge;
